import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";

import {
  MessageBox,
  Message,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popover,
  Collapse,
  CollapseItem,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Input,
  Switch,
  Tooltip,
  Button,
  Loading,
  DatePicker,
  Table,
  Pagination,
  TableColumn,
  Upload,
  Progress,
  Select,
  Option
} from "element-ui";

Vue.use(Dialog)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Popover)
  .use(Collapse)
  .use(CollapseItem)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Radio)
  .use(RadioGroup)
  .use(Input)
  .use(Switch)
  .use(Tooltip)
  .use(Button)
  .use(Loading.directive)
  .use(DatePicker)
  .use(Table)
  .use(TableColumn)
  .use(Pagination)
  .use(Upload)
  .use(Progress)
  .use(Select)
  .use(Option);
Vue.prototype.$loading = Loading.service;
Vue.component(MessageBox.name, MessageBox);
Vue.component(Message.name, Message);
